export const DEPARTMENT_QUERY_KEY = '/v2/departments-for-select' as const;

export const departmentQueryKey = {
  all: [DEPARTMENT_QUERY_KEY] as const,
  list: (searchText: string, excludeIds: string[] = []) => [
    ...departmentQueryKey.all,
    { searchText, excludeIds },
  ],
} as const;
